import { render, staticRenderFns } from "./Genders.vue?vue&type=template&id=9f32a168&scoped=true&"
import script from "./Genders.vue?vue&type=script&lang=js&"
export * from "./Genders.vue?vue&type=script&lang=js&"
import style0 from "./Genders.vue?vue&type=style&index=0&id=9f32a168&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f32a168",
  null
  
)

export default component.exports